<template>
  <div class="loading-spinner">
    <div class="spinner animate-spin"></div>
  </div>
</template>

<style>
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2rem;
  width: 97.41px;
}

.spinner {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-top: 4px solid gray;
}

</style>
